import React from 'react'

interface Props {
  termsOpened: boolean,
  handleOpenTerms: any
}

interface State {}

class TermsConditions extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.termsOpened ? 'terms-conditions-accessories fade-in':'terms-conditions-accessories fade-out'}>
          <div className='note-container'>
            <div className='note-title'>
              Condiciones y restricciones
            </div>
            <div className='note-text'>
            Los concesionarios determinan el precio de los accesorios.
            <br/>
            <br/>
            La disponibilidad de accesorios debe ser consultada directamente en los concesionarios.
            <br/>
            <br/>
            Las imágenes de los vehículos son meramente referenciales, por lo que puede existir variaciones respecto de los modelos comercializados en Colombia.
            <br/>
            <br/>
            La compatibilidad de los accesorios en los vehículos debe validarse en los concesionarios (Acuda a un asesor comercial del concesionario de su preferencia).
            <br/>
            <br/>
            La representación gráfica de los accesorios se asemeja bastante a la realidad, no obstante, se trata de imágenes referenciales 
            <br/>
            <br/>
            El uso de accesorios no originales podría ocasionar la pérdida de garantía del vehículo.
            </div>
            <div className='btn-exit' onClick={() => {this.props.handleOpenTerms()}}>
              Regresar
            </div>
          </div>
        </div>
      )
  }
}

export default TermsConditions